import { Injectable } from "@angular/core";
import { RestReadServiceBase } from "@definitiv-packages/angular-dba-library";
import { ObjektModelView, TodoModelView } from "../../../public-api";

@Injectable({
    providedIn: 'root'
})
export class ObjektViewService extends RestReadServiceBase<ObjektModelView> {
    constructor(
    ) {
        super("ObjektModelView", false);
    }

    public ObjektHasTodo(ObjektID: number): Promise<TodoModelView> {
        return this.postHttpRequest(this.baseUri + '/ObjektHasTodo', ObjektID);
    }    
        
}